import { Component, OnInit, Inject, ViewChild, AfterViewInit, ElementRef, inject } from '@angular/core';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { switchMap, catchError, filter, tap } from 'rxjs/operators';
import { forkJoin, lastValueFrom, of, throwError } from 'rxjs';
import { NotificacionesPushService } from 'src/app/services/auth/notificaciones-push.service';
import { MatInput } from '@angular/material/input';

import { ActualizaDatosService } from './../../../services/auth/actualiza-datos/actualiza-datos.service';
import { Router } from '@angular/router';
import { IResponse2FA, IResponseRestablecerPassword } from 'src/app/models/account/account.model';
import { HttpErrorResponse } from '@angular/common/http';
import { SistemaOperativoService } from 'src/app/services/sistema-operativo/sistema-operativo.service';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatSuffix, MatError } from '@angular/material/form-field';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSlideToggle } from '@angular/material/slide-toggle';


@Component({
    selector: 'app-modal-ingresar',
    templateUrl: './modal-ingresar.component.html',
    styleUrls: ['./modal-ingresar.component.scss'],
    imports: [CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatSuffix, MatIconButton, MatIcon, MatError, MatDialogActions, MatButton, MatSlideToggle]
})
export class ModalIngresarComponent implements OnInit, AfterViewInit {

  @ViewChild('passwordInput') passwordInput: ElementRef<HTMLInputElement>;
  @ViewChild('twoFactorCodeInput') twoFactorCodeInput: ElementRef<HTMLInputElement>;

  public soService = inject(SistemaOperativoService);
  formIniciar = new FormGroup({
    Usuario: new FormControl(null, Validators.required),
    Password: new FormControl(null, Validators.required),
    RememberMe: new FormControl(false, Validators.required),
    devicetoken: new FormControl("123sddsfewr" ),
    TwoFactorCode: new FormControl(null),
    SecureBrowser: new FormControl(false),
  });
  loading = false;
  procesando = false;
  msgError = '';
  isExcepcion2FA: boolean | null = null;
  timer: any;
  intervalo: number = 0;
  maskedEmail: string = '';
  maskedPhone: string = '';
  tiempoBloqueo: number = 0;
  contadorIntentos: number = 0;
  intentos: number = 0;
  pasoActual: 'contrasena' | 'codigo'  = 'contrasena';
  hide = true;
  vigenciaInfo: any = null;

  constructor(
    public dialogRef: MatDialogRef<ModalIngresarComponent>,
    private notiPushService: NotificacionesPushService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService, private router: Router, private actDatos: ActualizaDatosService,
    private snackBar: MatSnackBar,) { }

  ngOnInit() {
    this.formIniciar.patchValue(this.data.login);
    this.isExcepcion2FA = this.data.excepcion;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.passwordInput.nativeElement.focus();
    }, 5)
  }

  closeDialog() {
    this.dialogRef.close();
  }

  login() {
  const token = localStorage.getItem('AP-RTK');
  if (token) {
    this.abrirSnackBar('Ya existe una sesión activa. No es posible iniciar una nueva.', 'Autorización', 'errorSnackbar');
    return;
  }

    this.loading = true;
    this.msgError = '';
    this.actDatos.changeValue(this.data.login.Usuario);
    this.authService.generaTokenIncial().pipe(
      switchMap(itm => {
        if (itm) this.formIniciar.get('devicetoken').setValue(itm);

        // 🔥 Validar vigencia antes del login
        return this.authService.validarVigenciaPassword(this.formIniciar.value).pipe(
          catchError(err => {
            // ❌ Si contraseña expirada o error de vigencia
            this.loading = false;
            const errorMsg = err?.error?.Errores?.[0]?.Exception || 'Tu contraseña ha expirado.';
            
            if(err?.error?.Errores?.[0]?.Key === "ValidityError"){
              this.actDatos.changeValue(this.data.login.Usuario); 
              this.router.navigate(['restablecer-vigencia'], {
                state: { tipo: 'expirada' }
              });
            }
            if (JSON.stringify(errorMsg).includes("El usuario debe actualizar sus datos")) {
              this.router.navigate(['actualiza-datos']);
            }
            return throwError(() => errorMsg); 
          }),

          switchMap((vigencia: any) => {
            // 🔥 El login SIEMPRE continúa inmediatamente
            return this.authService.iniciarSesion(this.formIniciar.value).pipe(
              tap(response => {
                 this.vigenciaInfo = vigencia;
              }),
              catchError(err => {
                this.loading = false;
                return of({ error: err.error });
              }),
              switchMap(lnActual => {
                return forkJoin({
                  login: of({ lnActual }),
                  portalClasico: lnActual && !lnActual.error ? this.authService.iniciaSesionParalela(this.formIniciar.value).pipe(
                    catchError(err => of({ error: err.message }))
                  ) : of({ lnActual })
                })
              })
            );
          })
        );
      })
    ).subscribe(({ login: { lnActual } }) => {
      
      if (lnActual ? !lnActual.error : true) {
        this.authService.actualizaCreaSesion()
        .subscribe({
          next: async (_) => {
            // 🔹 Mostrar snackbar sin afectar flujo
            if (this.vigenciaInfo?.Respuesta?.ProximaAVencer) {
              const snackBarRef = this.snackBar.open(
                this.vigenciaInfo?.Respuesta?.Mensaje,
                'Actualizar ahora',
                { duration: 40000 }
              );

              snackBarRef.onAction().subscribe(() => {
                this.actDatos.changeValue(this.data.login.Usuario);
                this.router.navigate(['restablecer-vigencia'], {
                  state: { tipo: 'porVencer' }
                });
              });
            }

            if (lnActual?.path_default && !lnActual?.error) {
              const result = await this.router.navigate([lnActual.path_default]);
              // console.log('navigate result:', result);
            }
            this.closeDialog();
          },
          error: err => {
            console.error('actualizaCreaSesion error', err);
            this.abrirSnackBar(err, "Actualiza Sesión", "errorSnackbar");
          }
        });
        return;
      }
      this.loading = false;
      const err = lnActual?.error || [];
  
      if (!err.length) {
        if(err.message == 'VerifyTwoFactorCode'){
          this.contadorIntentos ++;
          this.manejarError(null, err.errorDescripcion);
          if(this.intentos == this.contadorIntentos)
            this.closeDialog();
        }
        else
          this.abrirSnackBar('Verifica tu contraseña.', `Autorización`, 'errorSnackbar');
        return;
      }
  
      err.forEach((element, index) => {
        if (element.Visible) this.msgError = index === 0 ? element.Exception : `${this.msgError} ${element.Exception}`;
      });
  
      if (JSON.stringify(err).includes("El usuario debe actualizar sus datos")) {
        this.router.navigate(['actualiza-datos']);
      }
  
      this.abrirSnackBar(this.msgError, `Autorización`, 'errorSnackbar');
      this.closeDialog();
    }, error => {
      //console.log(error);
      this.loading = false;
      this.abrirSnackBar(error, "Aviso", "errorSnackbar");
      this.closeDialog();
    });
  
    // this.authService.actualizaCreaSesion(this.data.login.Usuario).subscribe((_) => { });
  }


  private abrirSnackBar(mensaje: string, titulo: string, clase: string, temporalizador: number = 10000) {
    const config: MatSnackBarConfig = {
      duration: temporalizador,
      panelClass: clase,
    };
    this.snackBar.open(mensaje, titulo, config);
  }

  restablecerPassword(){
    this.procesando = true;
    const request = { Usuario : this.formIniciar.get("Usuario").value }
    this.authService.restablecerPassword(request).subscribe((respuesta) => {
      this.procesando = false;
      this.closeDialog();
      if(respuesta.validacion)  this.abrirSnackBar(respuesta.datos, "Restablecer contraseña", "exitoSnackbar");
      if(!respuesta.validacion)  this.abrirSnackBar(respuesta.datos, "Restablecer contraseña", "avisoSnackBar");
    }, error => {
      this.procesando = false;
      this.closeDialog();
      this.abrirSnackBar(error.datos, "Restablecer contraseña", "errorSnackbar");
    });
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  validarStep(){
    if (this.isExcepcion2FA)
      this.login();
    else
      this.getCode();
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  startCountdown(): void {
    this.timer = setInterval(() => {
      this.intervalo--;

      if (this.intervalo <= 0) {
        clearInterval(this.timer);
        this.intervalo = 0;
        this.msgError = 'El código ha expirado. Por favor, solicita un nuevo código.';
      }
    }, 1000);
  }

  public getCode(){
    this.procesando = true;
    if (this.twoFactorCodeInput) {
      this.twoFactorCodeInput.nativeElement.value = '';
    }
    this.authService.generaTokenIncial().pipe(
      switchMap(token => {
        if (token) this.formIniciar.get('devicetoken').setValue(token);
        return this.authService.obtenerCodigoAutenticador(this.formIniciar.value).pipe(
          catchError(err => {
            this.loading = false;
            return throwError(err);
          })
        );
      })
    ).subscribe((response: IResponse2FA) => {
      this.procesando = false;
      if(response.datos.Intervalo > 0){
        this.intervalo = 0;
        this.msgError = '';
        this.intervalo = response.datos.Intervalo;
        this.maskedEmail = response.datos.MaskedEmail;
        this.maskedPhone = response.datos.MaskedPhone;
        this.tiempoBloqueo = response.datos.TiempoBloqueo;
        this.intentos = response.datos.Intentos;
        this.startCountdown();
        this.pasoActual = 'codigo';
        this.formIniciar.get('TwoFactorCode')?.setValidators([Validators.required]);
        this.formIniciar.updateValueAndValidity();
      }
    }, error => {
      this.procesando = false;
      if (JSON.stringify(error.error).includes("El usuario debe actualizar sus datos")) {
        this.closeDialog();
        this.actDatos.changeValue(this.data.login.Usuario);        
        this.router.navigate(['actualiza-datos']);
      }
      
      this.manejarError(error, 'Ocurrió un error al obtener el código.')
    });
  }

  private manejarError(error: any, mensajePorDefecto: string, temporalizador: number = 7000): void {
    let errorMessage: string;
    const errors = (error?.error.datos) ? error?.error.datos : [];
    if (errors?.length > 0) {
      errorMessage = errors.map((element: { Exception: any; }) => element.Exception).join('\n');
      this.abrirSnackBar(errorMessage, `Autorización`, 'errorSnackbar', temporalizador);
    } else {
      this.abrirSnackBar(mensajePorDefecto, `Autorización`, 'errorSnackbar',temporalizador);
    }
  }
}
